"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownLink = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _BrowserDefaultFocusStyleContext = require("../../contexts/BrowserDefaultFocusStyleContext.js");
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../Icon/icons/IconCheck/index.js");
var _IconSelected = require("./IconSelected.js");
var _Link = require("./Link.js");
var _KeyboardDetectionContext = require("../../contexts/KeyboardDetectionContext.js");
var _layoutTheme = require("../../styles/layout-theme.js");
var _excluded = ["href", "disabled", "role", "divider", "component", "isHover", "isActive", "className", "size", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * DropdownLink is a list item that is a link in the dropdown.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-dropdown-dropdownlink--docs) |
 * [Encore site](https://encore.spotify.net/web/components/dropdown) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/DropdownLink) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=423-1130&t=uvnU5TzlyKmXuODT-1)
 */
var DropdownLink = exports.DropdownLink = /*#__PURE__*/_react["default"].forwardRef(function DropdownLink(_ref, ref) {
  var href = _ref.href,
    disabled = _ref.disabled,
    role = _ref.role,
    divider = _ref.divider,
    component = _ref.component,
    isHover = _ref.isHover,
    isActive = _ref.isActive,
    className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var componentOverride = href ? 'a' : 'span';
  var linkComponent = component || componentOverride;
  var _useContext = (0, _react.useContext)(_BrowserDefaultFocusStyleContext.BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext.useBrowserDefaultFocusStyle;
  var _useContext2 = (0, _react.useContext)(_KeyboardDetectionContext.KeyboardDetectionContext),
    isUsingKeyboard = _useContext2.isUsingKeyboard;
  return /*#__PURE__*/_react["default"].createElement(_Link.Link, Object.assign({
    ref: ref,
    className: (0, _classnames["default"])((0, _layoutTheme.textClass)(size === 'small' ? 'bodySmall' : 'bodyMedium'), className),
    href: !disabled ? href : undefined,
    disabled: disabled,
    "aria-disabled": disabled,
    role: disabled && linkComponent === 'a' ? 'link' : role,
    component: props.as ? undefined : linkComponent,
    $divider: divider,
    $useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle,
    $isUsingKeyboard: isUsingKeyboard,
    $isHover: isHover,
    $isActive: isActive,
    $size: size
  }, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.DropdownLink
  }), children, props.selected && /*#__PURE__*/_react["default"].createElement(_IconSelected.IconSelected, {
    $size: size
  }, /*#__PURE__*/_react["default"].createElement(_index.IconCheck, {
    size: "small"
  })));
});